import { websocketStore } from 'stores/webSocket'
import { messageHandlers } from './handlers'

const bmWebSocketUrl = import.meta.env.VITE_API_BM_WEBSOCKET_URL || 'wss://ws-bm.dev.sullivancotter.com'

export function connectToWebSocket(onMessageCallback) {
  const socket = new WebSocket(bmWebSocketUrl)

  let pingInterval

  socket.onopen = () => {
    console.log('WebSocket connected')
    pingInterval = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ product: 'bm' }))
      }
    }, 5 * 60 * 1000) // 5 minutes

    websocketStore.set(socket)
  }

  socket.onmessage = event => {
    console.log('Message received:', event.data)
    if (onMessageCallback) {
      onMessageCallback(event.data)
    }
  }

  socket.onerror = error => {
    console.error('WebSocket error:', error)
    cleanupSocket(pingInterval)
  }

  socket.onclose = () => {
    console.warn('WebSocket connection closed')
    cleanupSocket(pingInterval)
  }

  return socket
}

export function handleWebSocketMessage(event) {
  let data
  try {
    data = JSON.parse(event)
  } catch (err) {
    console.log('Invalid JSON in WebSocket message:', event, err)
    return
  }

  console.log('WebSocket message received:', data)

  const handler = messageHandlers[data.type] || messageHandlers.defaultHandler
  handler(data)
}

function cleanupSocket(pingInterval) {
  if (pingInterval) clearInterval(pingInterval)
  websocketStore.set(null)
}
